import type { TrainingModule } from "../types";
import { mountOrdersReaderPreflight } from "./preflight-ui";

export const ordersReaderModule: TrainingModule = {
  id: "orders-reader",
  title: "Orders Reader",
  featureFlag: "ordersReaderModule",
  render: () => ({
    kind: "content",
    heading: "Orders Reader",
    body: "Load an orders or warning-order Markdown file from this device. The file is never uploaded.",
    mount: mountOrdersReaderPreflight,
  }),
};
